import { useContext, useEffect } from 'react';
import Header from '../../components/Header';
import PokeContext from '../../context';
import PokeList from './components/PokeList';
import SearchBar from './components/SearchBar';

export default function PokeHome() {
	const {
		getPokemons,
		pokemons,
		isLoading,
		hasError,
		erroMessage,
		setPage,
		page,
		total,
		getPokemonDetail,
		setFavorites,
		search,
	} = useContext(PokeContext);

	
	useEffect(() => {
		const loadFavoritePokemons = () => {
			const pokemons =
				JSON.parse(window.localStorage.getItem('favorite_pokemon')) || [];
			setFavorites(pokemons);
		};
		loadFavoritePokemons();
	}, []);

	useEffect(() => {
		if (!search) {
			getPokemons().catch(null);
		}
	}, [page]);

	return (
		<div className="container">
			<Header />
			<div className="App">
				<SearchBar onSearchF={getPokemonDetail} />
				{hasError ? (
					<div className="errorMessage">No se encontro el Pokemon que buscabas 😭 {erroMessage} </div>
				) : (
					<PokeList
						loading={isLoading}
						pokemons={pokemons}
						page={page}
						setPage={setPage}
						total={total}
					/>
				)}
			</div>
		</div>
	);
}
